import React, { useEffect, useState } from 'react'
import { Card, Table, Button } from "antd";
import { getProductionCostsWithPage } from "../../services/serviceProductionCost";
import ProductionCostCreate from "./ProductionCostCreate";
import ProductionCostActions from "./ProductionCostActions";

const ProductionCost = () => {
    const [sortedList, setSortedList] = useState([]);
    const [createModal, setCreateModal] = useState(false);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getProductionCosts(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getProductionCosts = (page, pageSize) => {
        getProductionCostsWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getProductionCosts(1, 10);
        },
        modalCloser() {
            setCreateModal(!createModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    costName: item.name,
                    costCode: item.code,
                    costDescription: item.description,
                    costRatio: item.ratio
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    }


    const columns = [
        {
            title: 'Adı',
            dataIndex: 'costName',
            key: 'costName'
        },
        {
            title: 'Kodu',
            dataIndex: 'costCode',
            key: 'costCode'
        },
        {
            title: 'Oranı',
            dataIndex: 'costRatio',
            key: 'costRatio'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <ProductionCostActions record={record} updater={handlers.updater} />
        }
    ]

    return (
        <React.Fragment>
            <Card
                title={'Üretim Giderleri'}
                extra={
                    <Button
                        onClick={() => setCreateModal(!createModal)}
                        type={'primary'}
                    >
                        Yeni Ekle
                    </Button>
                }
            >
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {createModal ? <ProductionCostCreate show={createModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}

        </React.Fragment>
    )
}
export default ProductionCost